









































































import Vue from 'vue';
import { mapActions } from 'vuex';

import Sample from './sample.vue';
import { SAMPLES } from './config';

export default Vue.extend({
  name: 'Samples',

  components: {
    Sample,
  },

  props: {
    button: {
      type: String,
      default: 'primary',
    },
  },

  data: () => ({
    active: -1,

    open: false,

    samples: SAMPLES,
  }),

  methods: {
    ...mapActions('data', [
      'loadExampleData',
    ]),

    activate(index: number) {
      if (index === this.active) {
        this.active = -1;
      } else {
        this.active = index;
      }
    },

    async load() {
      if (this.active === -1) {
        return;
      }

      await this.loadExampleData(this.samples[this.active].key);
      this.$router.push('/cartography');
    },
  },
});
